import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  scrollContainer: {
    maxHeight: 600,
    overflowY: 'auto',
  },
}))

export default useStyles
